import { fabric } from 'fabric'

export const PX_PER_MM = 96 / 25.4

// Export in world coordinates regardless of pan/zoom, with enough precision
// for large transformed groups. Fabric's default two decimals lose geometry.
export function exportOffsetSVG(canvas) {
    const precision = fabric.Object.NUM_FRACTION_DIGITS
    try {
        fabric.Object.NUM_FRACTION_DIGITS = 8
        return canvas.toSVG({
            suppressPreamble: true,
            viewBox: { x: 0, y: 0, width: canvas.width, height: canvas.height },
        })
    } finally {
        fabric.Object.NUM_FRACTION_DIGITS = precision
    }
}

export async function loadOffsetBackground(svg) {
    const document = new DOMParser().parseFromString(svg, 'image/svg+xml')
    if (document.querySelector('parsererror')) throw new Error('SVG de offset inválido')
    const root = document.documentElement
    const viewBox = (root.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number)
    if (viewBox.length !== 4 || !viewBox.every(Number.isFinite) || viewBox[2] <= 0 || viewBox[3] <= 0) {
        throw new Error('El SVG de offset no contiene un viewBox válido')
    }
    // The viewBox describes the result's crop in canvas pixels. Removing its
    // camera keeps the paths at their original world positions on Fabric import.
    root.removeAttribute('viewBox')
    root.setAttribute('width', String(viewBox[2]))
    root.setAttribute('height', String(viewBox[3]))
    root.querySelectorAll('path,rect,circle,ellipse,polygon,polyline,line').forEach(element => {
        element.setAttribute('stroke', 'none')
        element.setAttribute('stroke-width', '0')
    })
    const source = new XMLSerializer().serializeToString(root)
    return new Promise((resolve, reject) => {
        fabric.loadSVGFromString(source, objects => {
            if (!objects.length) return reject(new Error('El offset no contiene geometría'))
            objects.forEach(object => object.set({ stroke: null, strokeWidth: 0 }))
            // Do not pass SVG viewport dimensions as Group dimensions: measure
            // the actual paths while retaining their absolute positions.
            const background = new fabric.Group(objects, {
                id: 'background', selectable: false, evented: false,
                hoverCursor: 'default', stroke: null, strokeWidth: 0,
            })
            background.setCoords()
            resolve(background)
        })
    })
}
